import { SubscriptionSubjectType, SubscriptionType } from "../../../types/Student";
import { put } from "../../../utils/axios-config";
import { SUBSCRIPTIONS, SUBSCRIPTIONS_SUBJECTS } from "../../../utils/constants";

export const updateSubscription = async (data: SubscriptionType) => await put<SubscriptionType, string>(SUBSCRIPTIONS, data);
export const updateSubscriptionSubject = async (data: SubscriptionSubjectType) => await put<SubscriptionSubjectType, string>(SUBSCRIPTIONS_SUBJECTS, data);